import {layout as bvLayout} from "../bvcomponents/bvComponent/bathroomVisualizer";
import {layout as kvLayout} from "../bvcomponents/kvComponent/kitchenVisualizer";
// import {layout as kvMasterLayout} from "../bvcomponents/kvMasterComponent/kvMasterVisualizer";
import {layout as kvSceneLayout} from "../bvcomponents/kvSceneComponent/kvSceneVisualizer";
import {layout as bvSceneLayout} from "../bvcomponents/bvSceneComponent/bvSceneVisualizer";
import {layout as bvLookLayout} from "../bvcomponents/look/lookVisualizer";
import {layout as fireplaceLayout} from "../bvcomponents/fireplace/fireplaceVisualizer";

import {Layout as bvLayoutInstance} from "../bvcomponents/bvComponent/core/layout";
import {Layout as kvLayoutInstance} from "../bvcomponents/kvComponent/core/layout";
// import {Layout as kvMasterLayoutInstance} from "../bvcomponents/kvMasterComponent/core/layout";
import {Layout as kvSceneLayoutInstance} from "../bvcomponents/kvSceneComponent/core/layout";
import {Layout as bvSceneLayoutInstance} from "../bvcomponents/bvSceneComponent/core/layout";
import {Layout as bvLookLayoutInstance} from "../bvcomponents/look/core/layout";
import {Layout as fireplaceLayoutInstance} from "../bvcomponents/fireplace/core/layout";

import ImageCanvasCommon from "./visComponents/imageCanvasCommon";
import ImageCanvasCommonNew from "./visComponents/imageCanvasCommonNew";

import bvZIndexes from "../bvcomponents/bvComponent/core/parts/zIndex";
import kvZIndexes from "../bvcomponents/kvComponent/core/zIndex";
// import kvMasterZIndexes from "../bvcomponents/kvMasterComponent/core/zIndex";
import kvSceneZIndexes from "../bvcomponents/kvSceneComponent/core/zIndex";
import bvSceneZIndexes from "../bvcomponents/bvSceneComponent/core/zIndex";
import bvLookZIndexes from "../bvcomponents/look/core/zIndex";
import fireplaceZIndexes from "../bvcomponents/fireplace/core/zIndex";

import {AVAILABLE_VISUALIZER_TYPES, getCommonVisualizerType} from "../config";
import {LOOK_ROOM_TYPES} from "./look/core/constants";

export const getCurrentLayout = (visualizerType = document.kvConfig.visualizerType) => { // layout should be dynamic (could be switched)
  switch (visualizerType) {
    case "Kitchen":
    case "KV":
      return kvLayout;
    case "Bathroom":
    case "BV":
      return bvLayout;
    // case "kvMaster":
    //   return kvMasterLayout;
    case "kvScene":
    case "KitchenV5":
      return kvSceneLayout;
    case "bvScene":
    case "BathroomV5":
      return bvSceneLayout;
    case "bvLook":
    case "BathroomV6":
      return bvLookLayout;
    case "Fireplace":
      return fireplaceLayout;
    default:
      // console.trace("Incorrect layout selected (document.kvConfig.visualizerType)");
      return null
  }
};

export const getCurrentLayoutInstance = (visualizerType = document.kvConfig.visualizerType) => { // is used for creating fake layouts (to show layouts, scenes, etc.), to show thumbnails
  switch (visualizerType) {
    case "Kitchen":
    case "KV":
      return kvLayoutInstance;
    case "Bathroom":
    case "BV":
      return bvLayoutInstance;
    // case "kvMaster":
    //   return kvMasterLayoutInstance;
    case "kvScene":
      return kvSceneLayoutInstance;
    case "bvScene":
      return bvSceneLayoutInstance;
    case "bvLook":
      return bvLookLayoutInstance;
    case "Fireplace":
      return fireplaceLayoutInstance;
    default:
      // console.trace("Incorrect layout selected (document.kvConfig.visualizerType)");
      return null
  }
};

export const getCurrentCanvas = (visualizerType = document.kvConfig.visualizerType) => { // layout should be dynamic (could be switched)
  switch (visualizerType) {
    case "Kitchen":
    case "KV":
    case "kvMaster":
    case "Bathroom":
    case "BV":
    case "bvScene":
      return ImageCanvasCommon;
    case "bvLook":
    case "kvScene":
    case "Fireplace":
    default:
      return ImageCanvasCommonNew;
  }
};


export const getCurrentZIndexes = (visualizerType = document.kvConfig.visualizerType) => {
  switch (visualizerType) {
    case "Kitchen":
    case "KV":
      return kvZIndexes;
    case "Bathroom":
    case "BV":
      return bvZIndexes;
    // case "kvMaster":
    //   return kvMasterZIndexes;
    case "kvScene":
      return kvSceneZIndexes;
    case "bvScene":
      return bvSceneZIndexes;
    case "bvLook":
      return bvLookZIndexes;
    case "Fireplace":
      return fireplaceZIndexes;
    default:
      // console.trace("Incorrect layout selected (document.kvConfig.visualizerType)");
      return null
  }
};

/**
 * Returns the fake created layout,
 * @param asLayout {object}
 * @param type {number} to filter features for this specific layout
 * @param scene {string} to filter features for this specific scene
 * @returns {object}
 */
export const createFakeLayout = (asLayout = getCurrentLayout(), type, scene) => {
  const LayoutInstance = getCurrentLayoutInstance(asLayout.visualizerType);
  const fakeLayout = new LayoutInstance();
  fakeLayout.isFakeLayout = true;
  const parentGroups = fakeLayout.getFeatures(true);
  let needToLoadFeatures = type || scene
    ? asLayout.allDbFeatures.filter(dbFeature => {
      if (!dbFeature.s3Bindings || !dbFeature.metaData) {
        return false
      }
      if (type && !dbFeature.metaData.RoomLayout || !dbFeature.metaData.RoomLayout.includes(type)) {
        return false
      }
      if (asLayout.isNewLayout && scene && !dbFeature.metaData.RoomScene || !dbFeature.metaData.RoomScene.includes(scene)) {
        return false
      }
      return true
    })
    : asLayout.allDbFeatures;
  // console.log("asLayout.allDbFeatures", asLayout.allDbFeatures);
  // console.log("needToLoadFeatures", needToLoadFeatures);
  for (let i = 0; i < needToLoadFeatures.length; i++) {
    fakeLayout.loadDbFeature(needToLoadFeatures[i], parentGroups)
  }
  fakeLayout.createCustomConfigurations(); // set shower body first
  fakeLayout.setDefaultFeatures();
  fakeLayout.initialized = true;
  return fakeLayout
};

/**
 * Returns the visualizer type from saved quote
 * @param bvScene {object} main object that passed between backend and frontend
 // * @param quoteObject {object} not required // main parent quote(room) object that passed between backend and frontend
 * @returns {string}
 */
export const getVisualizerTypeFromBvScene = (bvScene) => {
  if (bvScene.visualizerType) {
    return bvScene.visualizerType // this should be the most common case, but we still need to support old quotes :(
  }
  if (bvScene.bathroom_floor || bvScene.shower_body) {
    switch (document.kvConfig.toolVersion) {
      case 6:
        return AVAILABLE_VISUALIZER_TYPES.bvLook
      case 5:
        return AVAILABLE_VISUALIZER_TYPES.bvScene
      case 4:
      default:
        return AVAILABLE_VISUALIZER_TYPES.Bathroom
    }
  }
  if (bvScene.kitchen_floor) {
    return document.kvConfig.toolVersion === 5 ? AVAILABLE_VISUALIZER_TYPES.kvScene : AVAILABLE_VISUALIZER_TYPES.Kitchen
  }
  // return quoteObject ? quoteObject.room : ""
  return document.kvConfig.visualizerType
};

/**
 * @param layout {object}
 */
export const getCurrentRoomType = (layout = getCurrentLayout()) => {
  if (layout.type >= 10) {
    return LOOK_ROOM_TYPES.as
  }
  return LOOK_ROOM_TYPES.grohe
  // return IS_AS_BATHROOM ? LOOK_ROOM_TYPES.as : LOOK_ROOM_TYPES.grohe
};


/**
 * @param layout {object}
 * @returns featureGroup {featureGroupInterface}
 */
export const getCountertopFeatureGroup = (layout = getCurrentLayout()) => {
  let mainNeeded, oppositeNeeded;
  switch (getCommonVisualizerType(layout.visualizerType)) {
    case "kitchen":
      mainNeeded = "center_island_countertop";
      oppositeNeeded = "countertop";
      break;
    case "bathroom":
      mainNeeded = "vanity_countertop";
      oppositeNeeded = "vanity_backsplash";
      break;
    case "fireplace":
      mainNeeded = "front_wall";
      break;
    default:
      mainNeeded = "countertop";
      break;
  }
  let featureGroupCountertop = layout.getSubPartFromQtCategories(mainNeeded);
  if (!featureGroupCountertop && oppositeNeeded) {
    featureGroupCountertop = layout.getSubPartFromQtCategories(oppositeNeeded);
  }
  if (featureGroupCountertop) {
    return featureGroupCountertop.part
  }

  return layout.getFeatureGroupByPartId(mainNeeded) || (oppositeNeeded ? layout.getFeatureGroupByPartId(oppositeNeeded) : null)
}
